import { Fallback } from '~/pages/OperationLimits/Limits/components/Fallback';

function CounterpartyListEmpty() {
  return <Fallback py={16} message="Sem dados para os filtros aplicados!" />;
}

export default CounterpartyListEmpty;
